












































































































// vendor
import { defineComponent, computed, ref, watch, provide } from "@vue/composition-api";
import { format as formatDate } from "date-fns";
// projects
import * as AssetAPI from "@/services/api/assets";
import { Asset, AssetVersion } from "@/psychlab/types";
import { useAssets } from "@/hooks/useAssets";
import { PreviewAssetData } from "@/components.assets/preview-asset-data";
import { ContextOption } from "@/components.generic/context-menu";
import * as AppModal from "@/AppModal";
// local
import { AssetContext } from "./AssetContext";
import { default as UpdateButton } from "./update-button.vue";

export default defineComponent({
	components:{
		PreviewAssetData,
		UpdateButton,
	},
	setup(props, context){

		const {
			assets,
			getCachedAsset
		} = useAssets();

		const latestVersion = ref<AssetVersion<any>>();
		const assetId = computed(() => context.root.$route.params["assetId"]);

		const asset = computed(() => {
			return assets.value.find(a => a._id === assetId.value);
		});

		provide<AssetContext>("assetContext", {
			asset,
			assetId,
		});

		const lastModifiedLabel = computed(() => {
			if(!asset.value){ return ""; }
			return formatDate(new Date(asset.value.lastModified), "EEEE LLLL d Y @ HH:mm");
		})

		const isEditing = computed(() => {
			return context.root.$route.name === "asset.edit";
		});

		const isHistory = computed(() => {
			return context.root.$route.name === "asset-history";
		});

		const isViewing = computed(() => {
			return context.root.$route.name === "view-asset";
		});

		const viewRoute = computed(() => {
			return {
				name:"view-asset",
				params:{
					assetId:assetId.value
				}
			}
		});

		const editRoute = computed(() => {
			return {
				name:"asset.edit",
				params:{
					assetId:assetId.value
				}
			}
		});

		const historyRoute = computed(() => {
			return {
				name:"asset-history",
				params:{
					assetId:assetId.value
				}
			}
		});

		const showUpdate = computed(() => {

			if(asset.value?.type !== "Graph"){ return false; }

			return true;

		});

		const openRoute = (r:any) => {
			context.root.$router.push(r).catch(() => {})
		};

		const updateRefs = () => {

		};

		const rename = () => {
			const a = asset.value;
			if(!a){ return; }

			AppModal.editText({
				title:"Rename",
				value:a.name,
				validator(v){
					return v !== a.name && v.length > 1;
				}
			}, async (v) => {
				try {
					await AssetAPI.setAssetName(a._id, v);
					a.name = v;
				}
				catch(err){
					console.log(err.message);
				}
			})
			
		};
		
		const onUpdated = () => {
			init();
		};

		const openContext = (e:Event) => {

			const options:ContextOption[] = [
				{
					name:"Rename",
					icon:"mdi.pencil",
					fn:rename,
				},
			];

			if(!isViewing.value){
				options.push({
					name:"Overview",
					icon:"mdi.information-outline",
					fn(){
						openRoute(viewRoute.value);
					},
					order:1,
				});
			}

			if(!isEditing.value){
				options.push({
					name:"Edit",
					icon:"mdi.pencil-box",
					fn(){
						openRoute(editRoute.value);
					},
					order:2,
				});
			}

			if(!isHistory.value){
				options.push({
					name:"View History",
					icon:"mdi.history",
					fn(){
						openRoute(historyRoute.value);
					},
					order:3,
				});
			}


			AppModal.context(e, options);
		};
		

		const init = async() =>{
			latestVersion.value = await AssetAPI.getAssetVersion(assetId.value, "latest", "+data +vIndex");
			refreshPageTitle();
		};
		

		const refreshPageTitle = () => {
			if(!asset.value){ return; }
			document.title = `${asset.value.name}`;
		};

		init();

		watch(asset, () => {
			refreshPageTitle();
		});

		return {
			asset,
			latestVersion,
			editRoute,
			historyRoute,
			viewRoute,
			isEditing,
			isHistory,
			isViewing,
			lastModifiedLabel,
			openContext,
			updateRefs,
			showUpdate,
			onUpdated,
		};
	}
});

